import React from 'react';

// Placeholder for the Teams view
function Teams() {
  return <h1>Teams</h1>;
}

export default Teams;
